import type { ScopedConnectionItem } from './connection-api';
import { connectionReadinessMessage } from './connection-availability';
import { sharingCopyFor } from './sharing-copy.ts';

export function completedConnection(
  requested: ScopedConnectionItem,
  entries: ScopedConnectionItem[],
  previousIds: Set<string | null>,
) {
  return entries.find((entry) => {
    if (entry.id !== requested.id || entry.audience !== requested.audience) return false;
    if (requested.id.startsWith('pipedream:'))
      return (
        entry.status === 'connected' &&
        (entry.connectionId === requested.connectionId || !previousIds.has(entry.connectionId))
      );
    if (!entry.connectionId) return false;
    if (
      requested.authorizationVersion &&
      entry.authorizationVersion === requested.authorizationVersion
    )
      return false;
    return (
      entry.status === 'connected' ||
      Boolean(
        entry.authorizationVersion &&
        entry.readiness &&
        ['unavailable', 'needs_reauthorization'].includes(entry.status),
      )
    );
  });
}

export function connectionCompletionNotice(item: ScopedConnectionItem, locale?: string) {
  const copy = sharingCopyFor(locale);
  return (
    connectionReadinessMessage(item.readiness, locale) ??
    copy.completed.replace('{name}', item.name)
  );
}
